export default function getId (link = '') {
  return decodeURIComponent(link).split('/').slice(-1)[0]
}
